import Vue from 'vue';

Vue.directive('indeterminate', (el, binding) => {
  if (el.type && el.type === 'checkbox') {
    el.indeterminate = binding.value === null;
  }
});
